import React, { useCallback } from 'react';

import { useD3 } from "d3blackbox";
import { useDispatch } from "react-redux";

// import { extent, max } from "d3-array";
import { axisBottom } from "d3-axis";
import { brushX, brushSelection } from "d3-brush";
import { select } from 'd3-selection';

import { setTimeRange } from "../../store/actions";


const renderAxis = (anchor, xScale, margin, width, height, onBrushEnd) => {
  const g = select(anchor);

  // Basic axis
  const xAxis = axisBottom(xScale);
  const axisGroup = g.call(xAxis);

  // Basic brush
  const xMin = margin.left;
  const xMax = width - margin.right - margin.left;
  const yMin = 20;
  const yMax =  -20;

// ... capture a basic x brush
const onBrushed = function () {
  const selection = brushSelection(this);
  if (selection === null) {
    return;
  }

  const xSelection = selection.map(xScale.invert);

  onBrushEnd(xSelection[0] , xSelection[1]);
}

  const xBrush = brushX()
    .extent([
      [xMin, yMax],
      [xMax, yMin]
    ])
    .on('end', onBrushed);

  // TODO: replace with vx-brush to avoid needing to manually guard against making extras
  if (g.selectAll('g.x-brush')._groups[0].length === 0) {
    const brushGroup = g
      .append("g")
      .attr("class", "x-brush")
      .call(xBrush);
  }

  // TODO: decide if we actually care about being able to brush select different times of day
  // vs being able to click on stations and just see trips for those stations.
}

const BrushableAxis = ({ x = 0, y, xScale, margin, width }) => {
  const dispatch = useDispatch();

  const onBrushEnd = useCallback(
    (start, end) => dispatch(setTimeRange(start, end)),
    [dispatch]
  );

  const refAnchor = useD3(anchor => renderAxis(anchor, xScale, margin, width, y, onBrushEnd));

  return <g ref={refAnchor} transform={`translate(${x}, ${y})`} />;
};

export default BrushableAxis;
